import type { HTMLAttributes } from 'react';
import clsx from 'clsx';

type Tone = 'neutral' | 'accent' | 'warning' | 'success' | 'danger' | 'violet' | 'pink';

const toneClasses: Record<Tone, string> = {
  neutral: 'bg-surface-700 text-ivory-300',
  accent: 'bg-accent-500/20 text-accent-300',
  warning: 'bg-warning-500/20 text-warning-400',
  success: 'bg-success-500/20 text-success-400',
  danger: 'bg-danger-500/20 text-danger-400',
  violet: 'bg-violet-500/20 text-violet-300',
  pink: 'bg-pink-500/20 text-pink-400',
};

export function Badge({ tone = 'neutral', className, ...rest }: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      className={clsx('inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium', toneClasses[tone], className)}
      {...rest}
    />
  );
}
